import { FaCalendar, FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaUser, FaTags, FaBusinessTime, FaBriefcase, FaMoneyBillWave, FaHourglassEnd, FaCalendarAlt, FaGasPump, FaPhone, FaCheckCircle, FaUsers, FaSuitcaseRolling, FaCity, FaPlaneDeparture, FaCrown, FaBus } from 'react-icons/fa';



// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'city rides':
      return <FaCity />; // City icon representing urban rides
    case 'airport transfers':
      return <FaPlaneDeparture />; // Airplane icon representing airport drop-offs/pickups
    case 'corporate rides':
      return <FaBriefcase />; // Briefcase icon representing business travel
    case 'luxury rides':
      return <FaCrown />; // Crown icon representing premium and luxury rides
    case 'group rides':
      return <FaUsers />; // Users icon representing shared or group travel
    case 'shuttle services':
      return <FaBus />; // Bus icon representing shuttle transportation


    /*----- Case Single -----*/
    case 'date':
      return <FaCalendar />; // Calendar icon for selecting a date
    case 'client':
      return <FaUser />; // User icon representing the client
    case 'category':
      return <FaTags />; // Tags icon representing the project category
    case 'duration':
      return <FaClock />; // Clock icon representing the project duration
    case 'location':
      return <FaMapMarkerAlt />; // Map marker icon indicating the location
    case 'cost':
      return <FaDollarSign />; // Dollar sign icon representing the cost or budget
    case 'projectmanager':
      return <FaUserTie />; // UserTie icon representing the project manager


    /*----- Career Single -----*/
    case 'timing':
      return <FaClock />; // Clock icon for general timing
    case 'hours':
      return <FaBusinessTime />; // BusinessTime icon for working hours
    case 'experience':
      return <FaBriefcase />; // Briefcase icon for experience level
    case 'position':
      return <FaUserTie />; // UserTie icon for job position
    case 'days':
      return <FaCalendarAlt />; // Calendar icon for days worked
    case 'salary':
      return <FaMoneyBillWave />; // MoneyBillWave icon for salary representation
    case 'deadline':
      return <FaHourglassEnd />; // HourglassEnd icon for deadline
    case 'number':
      return <FaPhone />; // Phone icon for contact numbers


    /*----- Taxi Single -----*/
    case 'passengers':
      return <FaUsers />; // Users icon for passenger capacity  
    case 'luggages':
      return <FaSuitcaseRolling />; // Suitcase icon representing luggage  
    case 'fueltype':
      return <FaGasPump />; // Gas pump icon for fuel type  
    case 'costpermile':
      return <FaDollarSign />; // Dollar sign icon representing cost per mile  
    case 'availability':
      return <FaCheckCircle />; // Check circle icon representing availability status  
    case 'operatinghours':
      return <FaClock />; // Clock icon representing operating hours

    default:
      return null; // Return null if no matching icon is found

  }

};